import {
  isRequired,
  type Validation,
} from './utils';

const validations: Validation[] = [
  ({ name }) => (typeof name === 'string' && isRequired(name)) || { name: 'Vendor name is required.' },
  ({ description }) => (
    description === undefined
    || description === null
    || typeof description === 'string'
  ) || { description: 'Description should be string.' },
  ({ notes }) => (
    notes === undefined
    || notes === null
    || typeof notes === 'string'
  ) || { notes: 'Notes should be string.' },
];

const KEYS = [
  'name',
  'description',
  'notes',
];

export {
  validations,
  KEYS,
};
